import { createContext, useContext, useState } from 'react'
import { classificationService } from '../services/classificationService'
import { useUtiles } from './utilesContext'


const ClassificationContext = createContext()

export const useClassification = () => useContext(ClassificationContext)


export const ClassificationProvider = ({ children }) => {




    const [classifications, setClassifications] = useState([])
    const [loading, setLoading] = useState(false)

    const { setAlertSnackbar, restorePreviousComponent } = useUtiles()

    const getClassification = async (params) => {
        try{
            setLoading(true)
            const response = await classificationService.getClassification(params)
            setClassifications(response.data)
            console.log(params, response.data)
        }catch(error){
            console.log(error)
        }
        finally{
            setLoading(false)
        }
    }

    const [loadingCreateClassification, setLoadingCreateClassification] = useState(false)
    const createClassification = async (data) => {
        try{
            setLoadingCreateClassification(true)
            const response = await classificationService.createClassification(data)
            setClassifications([...classifications, response.data])
            await getClassification()
            setAlertSnackbar({
                open: true,
                message: 'Clasificación creada correctamente',
                severity: 'success'
            })
            restorePreviousComponent()

        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
            
        }
        finally{
            setLoadingCreateClassification(false)
        }
    }

    return (
        <ClassificationContext.Provider value={{ classifications, setClassifications, loading, getClassification, createClassification, loadingCreateClassification }}>{children}</ClassificationContext.Provider>
    )
}